import React, { CSSProperties } from "react";
import whitelabel from "../whitelabel";

export default function IconGPSOff(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M20.94 11A8.994 8.994 0 0 0 13 3.06V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06A8.994 8.994 0 0 0 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06A8.994 8.994 0 0 0 11 20.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06A8.993 8.993 0 0 0 20.94 13H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06ZM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7Z"
				fill={whitelabel.palette.secondary900}
			/>
			<path
				d="M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm2.475 2.523a1 1 0 0 0-1.415 0L12 10.584l-1.06-1.06a1 1 0 0 0-1.415 1.414l1.06 1.06-1.06 1.06a1 1 0 0 0 1.415 1.415l1.06-1.06 1.06 1.06a1 1 0 1 0 1.415-1.414l-1.06-1.061 1.06-1.06a1 1 0 0 0 0-1.415Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
